import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Icon from '../AppIcon';
import Button from '../ui/Button';
import LanguageSelector from '../LanguageSelector';
import { useLanguage } from '../../contexts/LanguageContext';

const PublicHeader = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();
  const { t } = useLanguage();

  const navigationItems = [
    { label: t('nav.features'), path: '#features' },
    { label: t('nav.howItWorks'), path: '#how-it-works' },
    { label: t('nav.about'), path: '#about' },
  ];

  const quickLinks = [
    { label: t('nav.forCompanies'), path: '/senior-professionals-gallery', icon: 'Briefcase' },
    { label: t('nav.forCandidates'), path: '/access-request', icon: 'User' },
  ];

  const handleNavClick = (e, path) => {
    if (path?.startsWith('#')) {
      e?.preventDefault();
      const element = document.querySelector(path);
      if (element) {
        element?.scrollIntoView({ behavior: 'smooth' });
      }
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <>
      <header className="public-header">
        <div className="public-header-container">
          <Link to="/marketing-landing" className="public-header-logo">
            <span className="public-header-logo-text text-2xl font-bold">BlinD</span>
          </Link>

          <nav className="public-header-nav">
            {navigationItems?.map((item) => (
              <a
                key={item?.label}
                href={item?.path}
                onClick={(e) => handleNavClick(e, item?.path)}
                className="public-header-nav-link"
              >
                {item?.label}
              </a>
            ))}
          </nav>

          <div className="public-header-cta">
            <LanguageSelector />
            <Button
              variant="outline"
              size="default"
              onClick={() => window.location.href = '/access-request'}
              className="hidden sm:flex"
            >
              {t('hero.requestAccess')}
            </Button>
            <button
              className="public-header-mobile-toggle"
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              aria-label="Toggle mobile menu"
            >
              <Icon name={isMobileMenuOpen ? 'X' : 'Menu'} size={24} />
            </button>
          </div>
        </div>
      </header>
      {isMobileMenuOpen && (
        <div className="public-header-mobile-menu">
          <div className="public-header-mobile-menu-content">
            {navigationItems?.map((item) => (
              <a
                key={item?.label}
                href={item?.path}
                onClick={(e) => handleNavClick(e, item?.path)}
                className="public-header-mobile-menu-link"
              >
                {item?.label}
              </a>
            ))}
            <div className="mb-4">
              <LanguageSelector />
            </div>
            <Button
              variant="default"
              size="lg"
              fullWidth
              onClick={() => {
                window.location.href = '/access-request';
                setIsMobileMenuOpen(false);
              }}
            >
              {t('hero.requestAccess')}
            </Button>
          </div>
        </div>
      )}
    </>
  );
};

export default PublicHeader;